import React from "react";
import { STATUS_META } from "@/lib/constants";

const toneClasses = {
  success: "bg-emerald-50 text-emerald-800 border border-emerald-200",   // VERIFIED
  info: "bg-sky-50 text-sky-800 border border-sky-200",                  // SUBMITTED
  warning: "bg-amber-50 text-amber-900 border border-amber-200",         // REVISION
  destructive: "bg-rose-50 text-rose-800 border border-rose-200",        // REJECTED
  muted: "bg-slate-100 text-slate-700 border border-slate-200",          // UNVERIFIED
  gold: "bg-[#FFF3D0] text-[#8A6A00] border border-[#F0D778]",           // PARTIAL
  review: "bg-violet-50 text-violet-800 border border-violet-200",       // UNDER REVIEW
  primary: "bg-primary/10 text-primary border border-primary/25",
};

export function StatusBadge({ status, label }) {
  const meta = STATUS_META[status];
  const tone = meta?.tone || (toneClasses[status] ? status : "muted");
  const displayLabel = label || meta?.label || status;
  return (
    <span
      className={`status-badge ${toneClasses[tone] || toneClasses.muted}`}
      data-testid={`status-${status}`}
    >
      {displayLabel}
    </span>
  );
}
